"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Group = void 0;

var _permission = require("./permission");

class Group {
  constructor() {
    this.id = void 0;
    this.name = void 0;
    this.createdAt = void 0;
    this.permissions = void 0;
  }

  static fromJson(json) {
    const group = new Group();
    group.id = json.id;
    group.name = json.name;
    group.createdAt = new Date(json.created_at);
    group.permissions = json.permissions.map(p => _permission.Permission.fromJson(p));
    return group;
  }

}

exports.Group = Group;